export default __webpack_public_path__ + "static/media/person1.aa2ce411.jpg";